import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { fetchClient, formatHeaders } from '@nike/fetch-client';
import { DOTCOM_UX_ID } from '@nike/ux-tread-dotcom-constants';
var getFetchValueAddedServicesOptions = function getFetchValueAddedServicesOptions(_ref) {
  var id = _ref.id;
  return {
    queryKey: ['merch/value_added_services/v1', {
      id: id
    }],
    queryFn: function queryFn() {
      var headers = formatHeaders({
        appId: DOTCOM_UX_ID,
        appName: 'CiCCart'
      });
      return fetchClient("".concat(process.env.NEXT_PUBLIC_API_HOST_NAME, "/merch/value_added_services/v1/").concat(id), {
        method: 'GET',
        headers: _objectSpread({
          'Content-Type': 'application/json; charset=UTF-8'
        }, headers)
      });
    },
    staleTime: Infinity
  };
};
export default getFetchValueAddedServicesOptions;